// extracted by mini-css-extract-plugin
export default {"formSection":"FormSection_formSection__lxZwC","imageContainer":"FormSection_imageContainer__+hsfI"};